import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WebcamImage } from 'ngx-webcam';
import { CommonService, DocumentsService } from '../../services/common';
import { DomSanitizer } from '@angular/platform-browser';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-document-file',
  templateUrl: './document-file.component.html',
  styleUrl: './document-file.component.scss'
})

export class DocumentFileComponent implements OnChanges {
  @Input() fileDataConfig: any
  @Output() documentFile = new EventEmitter<any>();
  @ViewChild('docInputFile', { static: false })
  docInputFile!: ElementRef;

  documentForm!: FormGroup
  displayCameraDialogue = false;
  currentFile?: File | null;
  currentFileBytes: any;
  cameraPicData: any;
  cameraPicArrayIndex: number = -1
  documentNumber!: string
  enableSubmit: boolean = false
  pdfFileObject: any;

  constructor(private fb: FormBuilder, private commonService: CommonService, private documentService: DocumentsService
    , private sanitizer: DomSanitizer
  ) { }



  ngOnInit() {
    this.initiateUserForm()
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initiateUserForm()
  }


  /**
 * User Document KYC Form Controls Key
 */


  initiateUserForm() {
    this.resetForm();
    this.documentForm = this.fb.group({
      DocumentSubTypeId: this.fileDataConfig?.documentSubTypeId,
      documentNumber: this.fileDataConfig?.documentNumber ? this.fileDataConfig?.documentNumber : this.documentForm?.value?.documentNumber,
      documentDate: this.fileDataConfig?.documentDate,
      isActive: true,
      isVerified: false,
      userId: this.fileDataConfig?.userId,
      projectId: this.fileDataConfig?.projectId,
      Document: [null, Validators.required]
    })

    //when file data config has existing pdf file then set the pdf file object to view the pdf
    if (this.fileDataConfig?.documentByte && this.fileDataConfig?.fileType?.toLowerCase() == 'pdf') {
      this.setPDFFileObject(this.fileDataConfig?.documentByte);
    }
  }

  //#region  CAMERA Operations
  displayCamera(picTitle: any, picFor: any, index: number = -1) {
    picTitle = picTitle.replace('{{ recordFor }}', picTitle)

    this.cameraPicData = {
      "picTitle": this.fileDataConfig.picFor,
      "picFor": picFor
    }

    if (index != -1)
      this.cameraPicArrayIndex = index
    this.displayCameraDialogue = true
  }

  receiveCapturedImage(capturedPicData: any) {
    //Set pics to respective variables for which camera pic was clicked. If camera pic not taken and operation got cancelled
    //then that variable value will remain to previous value
    if (capturedPicData?.capturedPic) {
      if (this.cameraPicArrayIndex == -1) {
        //When pic is clicked for a control on form
        this.currentFileBytes = capturedPicData?.capturedPic.imageAsDataUrl;
        this.fileDataConfig.fileType = "jpeg";
        //Convert camera image to file
        this.currentFile = this.convertWebCamImageToFile(this.currentFileBytes)
        this.documentForm.value.Document = this.currentFile
        this.enableSubmit = true
      }
      else if (this.cameraPicArrayIndex >= 0) {
        //When pic is clicked for an array
        // this.addPictoControlArray(
        //   this.commonService.BaseStringToNormalStrings(capturedPicData?.capturedPic.imageAsDataUrl),
        //   this.cameraPicArrayIndex,
        //   capturedPicData?.picFor
        // )
      }
    }
    //after finishing capturing the pic reset the cameraPicIndex back to -1 as nex pic may be clicked for form array
    this.cameraPicArrayIndex = -1

    this.displayCameraDialogue = false
  }
  //#endregion CAMERA Operations


  //#region Browsed Pic Operations

  /**
   * Sets browsed pic by file choose control
   * @param picFor document for which file was browsed
   * @param event
   */
  setBrowsedPic(picFor: any, event: any) {
    this.currentFile = event.target.files[0];
    var fileType = this.currentFile?.name.split('.').pop()?.toLowerCase();
    const reader = new FileReader();
    if (this.currentFile != null) {
      reader.readAsDataURL(this.currentFile);
      reader.onload = () => {
        this.fileDataConfig.documentByte = null;
        this.fileDataConfig.fileType = fileType;
        if (fileType?.toLowerCase() == 'pdf') {
          let base64String = reader.result as string;
          this.setPDFFileObject(base64String);
        }

        this.currentFileBytes = reader.result as string;
        this.enableSubmit = true
      }
    }
  }
  //#endregion Browsed Pic Operations

  /**
   * Sets the PDF file object to view the pdf in modal
   * @param docFileBytes document file bytes
   */
  setPDFFileObject(docFileBytes: any) {
    this.pdfFileObject = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.documentService.convertBase64ToFile(docFileBytes, 'pdf')
    )
  }

  /**
   * Converts the webcam image to file
   * @param camImage webCam image
   * @returns returns file
   */
  convertWebCamImageToFile(camImage: any) {
    const arr = camImage.split(",");
    if (arr.length > 0) {
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      const file: File = new File([u8arr], 'image.jpeg', { type: mime })
      return file;
    }
    return null;
  }

  /**
 * Document Save/Update Post API
 * @param data
 */
  returnDocumentPic() {

    if (this.fileDataConfig?.showDocumentNumber && !this.documentForm?.value?.documentNumber) {
      alert("Please enter the document number.")
      return
    }
    else if (this.fileDataConfig?.showDocumentDate && !this.documentForm?.value?.documentDate) {
      alert("Please enter the document Date.")
      return
    } else {
      this.fileDataConfig.document = this.currentFile
      this.fileDataConfig.documentByte = this.currentFileBytes
      this.fileDataConfig.documentNumber = this.documentForm?.value?.documentNumber ? this.documentForm?.value?.documentNumber : this.fileDataConfig?.documentNumber

      var docuementDate = this.documentForm?.value?.documentDate ? this.documentForm?.value?.documentDate : this.fileDataConfig?.documentDate
      if (docuementDate)
        this.fileDataConfig.documentDate = formatDate(docuementDate, 'dd/MM/yyyy', 'en-IN');

      this.fileDataConfig.documentSubTypeId = this.documentForm?.value?.DocumentSubTypeId,
        this.fileDataConfig.isActive = true,
        this.fileDataConfig.isVerified = false



      this.documentFile.emit({
        "displayDocumentFileModal": false,
        "documentFile": this.fileDataConfig,
      })

      this.resetForm();
      this.docInputFile.nativeElement.value = null;
    }
  }

  /**
   * Closes the document file modal. without impacting current files
   */
  ClosePicModal() {

    this.documentFile.emit({
      "displayDocumentFileModal": false,
      "documentFile": null
    })
    this.resetForm();
    this.docInputFile.nativeElement.value = null;
  }

  get f(): { [key: string]: AbstractControl } {
    return this.documentForm.controls
  }

  resetForm() {
    if (this.documentForm?.controls) {
      this.documentForm.reset();
    }

    this.pdfFileObject = null;
    this.currentFile = null;
    this.documentNumber = ''
    this.currentFileBytes = null;
    this.enableSubmit = false;
  }
}


